/**
 * 获取下一个编码
 * @param prefix
 * @param maxCode
 * @param length
 * @returns {string}
 */
export function getNextCode(prefix, maxCode, length) {
  if (maxCode == null) {
    let str = '';
    for (let i = 0; i < length - 1; i++) {
      str += '0';
    }
    return prefix + str + 1;
  } else {
    let str = '';
    let sno = parseInt(maxCode.substring(prefix.length)) + 1;
    for (let j = 0; j < length - sno.toString().length; j++) {
      str += '0';
    }
    return prefix + str + sno;
  }
}

// 重置弹窗data和form数据，formRef为表单的ref值，excludeFields为要排除重新初始化值的属性
// this.$data是已经转成了getter和setter，所以拿到的是一个修改后的数据
// this.$options.data()是刚刚传入vue里边，成员没有转成了getter和setter,所以拿到的仅仅是注入vue实例的初始数据
export function dialogFormReset(formRef, ...excludeFields) {
  let obj1 = this.$data;
  let obj2 = this.$options.data.call(this);
  if (!excludeFields || excludeFields.length === 0) {
    excludeFields = ['ruleValidate'];
  }
  for (let attrName in obj1) {
    if (excludeFields && excludeFields.includes(attrName)) {
      continue;
    }
    obj1[attrName] = obj2[attrName];
  }

  if (formRef) {
    this.$nextTick(() => {
      this.$refs[formRef].clearValidate();
    });
  }
}

// texarea换行转换html段落展示
export function textareaLineBreak(str) {
  if (str) {
    const lineArray = str.split('\n');
    return lineArray.map(item => `<div style="text-indent:2em">${item}</div>`).join('');
  } else {
    return str;
  }
}

// 页面返回
export async function goBack() {
  const { visitedViews } = await this.$store.dispatch('tagsView/delView', this.$route);
  const latestView = visitedViews.slice(-1)[0];
  this.$nextTick(() => {
    if (latestView) {
      this.$router.push(latestView.fullPath);
    } else {
      this.$router.push({
        path: '/'
      });
    }
  });
}
